import Box from '@mui/material/Box';
import { PageHeader } from 'components/PageHeader';
import { ErrorFallbackScreen } from 'components/screens';
import { AssignmentChangeLog } from 'modules/assignment-change-log';
import {
  AssignmentDetails,
  AssignmentDetailsContextProvider
} from 'modules/assignment-details';
import { getTrans } from 'modules/i18n';
import { Layout } from 'modules/minimal-ui-theme';
import { FeatureFlag, useFeatureToggle } from 'modules/unleash';

export const AssignmentDetailsPage = () => {
  const { isEnabled: isAssignmentManagementEnabled, isLoading } =
    useFeatureToggle(FeatureFlag.PRO_TALENT_IS_ASSIGNMENT_MANAGEMENT_ENABLED);

  if (isLoading) return null;

  if (!isAssignmentManagementEnabled) {
    return <ErrorFallbackScreen />;
  }

  return (
    <AssignmentDetailsContextProvider>
      <Layout
        header={
          <PageHeader
            title={getTrans('assignmentDetailsPage.title')}
            withBackBtn
          />
        }
        withFooter
      >
        <Box sx={{ pt: 10 }}>
          <AssignmentDetails />
          <AssignmentChangeLog />
        </Box>
      </Layout>
    </AssignmentDetailsContextProvider>
  );
};
